import React, { useContext } from "react";
import Bread from "../../common/Bread";
import { BsTelephoneForwardFill, BsFillPhoneFill } from "react-icons/bs";
import { MdEmail } from "react-icons/md";
import { LangContext } from "../../context/LangContext";
import "./teams.scss";

const ItTeams = ({ data }) => {
  const lang = useContext(LangContext);
  const nep = lang.state.np;

  // Choose language-specific items
  const items = nep ? data?.items?.np : data?.items?.en;

  const breadcrumList = {
    image: "",
    title: nep ? "आईटी अधिकारीहरू" : "IT Officials",
    l1: nep ? "होम" : "Home",
    l2: nep ? "टीमहरू" : "Teams",
    l3: nep ? "आईटी अधिकारीहरू" : "IT Officials",
  };

  return (
    <Bread data={breadcrumList}>
      <div className="officers-grid-container">
        {items?.map((i, index) => (
          <div key={index} className="officer">
            <div className="branch">
              <h3>{i.sub_designation}</h3>
            </div>

            <div className="paper">
              <div className="detail-container">
                <img src={i.featured_image} alt={i.email} />
                <p className="officer-name">{nep ? i.name_nepali : i.name}</p>
                <div>
                  <MdEmail />
                  <p>{i.email}</p>
                </div>

                <div>
                  <BsTelephoneForwardFill />
                  <p>01-4425292</p>
                </div>

                <div>
                  <BsFillPhoneFill />
                  <p>{i.contact}</p>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </Bread>
  );
};

export default ItTeams;
